<template>
  <div class="flex z-20 justify-center items-center speech-bubble speech-bubble:after absolute left-0 top-10 w-72 h-18 bg-white shadow-xl border border-customSoftGray rounded-lg">
    <h2 class=" text-xs text-center w-9/12">{{information}}</h2>
    <div id="arrow" data-popper-arrow></div>
  </div>
  
</template>

<script>
export default {
name:"InfoPopUp",

props: {
    information: {
        type: String,
        require:true
    },
},
}
</script>

<style scoped>
 .speech-bubble {
	background: white;
}

.speech-bubble:after {
  	width: 20px;
	content: '';
	position: absolute;
	top: 0;
	left: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
  	transform: rotateX(90);
	border-bottom-color: white;
  	box-shadow: midnightblue;
	border-top: 0;
	margin-left: -20px;
	margin-top: -20px;
}
 </style>